<template>
  <point-detail is-create />
</template>

<script>
import PointDetail from './detail'
export default {
  name: 'CreatePointGoods',
  components: { PointDetail }
}
</script>
